/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AsiCustomerDto } from '../../models/asi-customer-dto';

export interface GetCustomerInfo$Params {

/**
 * the customer id (can be number or uuid)
 */
  id: string;
}

export function getCustomerInfo(http: HttpClient, rootUrl: string, params: GetCustomerInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<AsiCustomerDto>> {
  const rb = new RequestBuilder(rootUrl, getCustomerInfo.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AsiCustomerDto>;
    })
  );
}

getCustomerInfo.PATH = '/auth/customerInfo/{id}';
